<template>
  <div id="app">
    <router-view/>
    <customer-service-fab v-if="showCustomerService" />
  </div>
</template>

<script>
import CustomerServiceFab from '@/components/CustomerServiceFab/index.vue'
import { trackSiteVisit } from '@/api/site'

const UV_FLAG = 'mzz_uv_seen_v1'

export default {
  name: 'App',
  components: { CustomerServiceFab },
  computed: {
    showCustomerService() {
      const route = this.$route || {}
      if (route.meta && route.meta.hideCustomerService) return false
      const path = route.path || ''
      if (path === '/v' || path.indexOf('/v/') === 0) return false
      if (path === '/complaint' || path.indexOf('/complaint') === 0) return false
      if (path === '/qr.php') return false
      return true
    }
  },
  created() {
    this.$store.dispatch('loadSiteConfig')
    this.pingSiteVisit()
  },
  methods: {
    pingSiteVisit() {
      try {
        const path = (this.$route && this.$route.path) || ''
        // 扫码公开页不计入后台「网站访问」
        if (path === '/v' || path.indexOf('/v/') === 0 || path === '/complaint') return
        let returning = false
        try {
          returning = localStorage.getItem(UV_FLAG) === '1'
        } catch (e) {}
        trackSiteVisit({ returning }).then(() => {
          try {
            localStorage.setItem(UV_FLAG, '1')
          } catch (e) {}
        }).catch(() => {})
      } catch (e) {}
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  height: 100%;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html {
  scroll-behavior: smooth;
}

body {
  overscroll-behavior-y: contain;
}

#app {
  background-color: #ffffff;
}
</style>
